export const path = "/social-media-aluna";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "RRSS",
  section: "ALUNA",
  group: null,
  order: 5,
  roles: [
    "Authenticated",
    "design",
    "design-roundler",
    "master-rrss-roundler",
    "master-aluna-rrss",
    "roundler-admin",
    "aluna",
    "aluna-afiliado",
  ],
};
